require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-minihof-liebau.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-minihof-liebau");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-minihof-liebau!./.cache/json/betreuungseinrichtungen-jennersdorf-minihof-liebau.json
// module id = 915
// module chunks = 231608221292675